import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isMMT: true
}

const mmtCommonSlice = createSlice({
    name: 'mmtCommon',
    initialState,
    reducers: {
        isMMT: (state, action) => {
            state.isMMT = action.payload;
        }
    }
})

export const { isMMT } = mmtCommonSlice.actions;
export default mmtCommonSlice.reducer